import { useAnalytics } from "@codat/analytics";
import { IntegrationsResponse, SourceTypesQueryResponse } from "api/company";
import { ConfigResponse } from "api/shared";
import { useEffect, useState } from "react";

export const usePageViewedEvent = (args: {
  ready: boolean;
  clientConfig?: ConfigResponse;
  sourceTypes?: SourceTypesQueryResponse;
  integrations?: IntegrationsResponse;
  data?: object;
  resetOnChange?: unknown;
}) => {
  const analytics = useAnalytics();
  const [sent, setSent] = useState(false);

  useEffect(() => {
    setSent(false);
  }, [args.resetOnChange]);

  useEffect(() => {
    if (args.ready && !sent) {
      const properties = {
        sourceTypes: args?.sourceTypes?.map((s) => s.sourceType),
        hasCustomRedirect: args?.clientConfig?.hasCustomRedirect,
        integrations: args?.integrations?.results.map((r) => {
          return {
            key: r.key,
            name: r.name,
          };
        }),
        ...args.data,
      };

      analytics.sendEvent("Page view", properties);
      setSent(true);
    }
  }, [args, sent, analytics]);
};
